import cloneDeep from 'lodash/cloneDeep'

export default {
	name: 'Onglets',
	emits: ['input'],
	data() {
		return {
			active: null
		}
	},
	props: {
		value: {
			type: String|Number,
			default: null
		},
		onglets: {
			type: Array,
			default: []
		},
		offset: {
			type: Number,
			default: 10
		}
	},
	mounted() {
		this.active = cloneDeep(this.value)
		if(!this.active) {
			this.active = this.onglets[0].code
		}
	},
	methods: {
		selectOnglet(code) {
			this.active = code;
			this.$emit('input', code);
		}
	}
}
